import { origin as _origin } from '@jarvis.oddle/core/env'

export const API_ROOT = '/api/fesc/v1'
export const IG_API_ROOT = `${API_ROOT}/instagram`
export const CUST_API_ROOT = `${API_ROOT}/customisation`
export const PORT = process.env.PORT || 50000
export const origin = _origin(PORT)

